/**
 * Convierte un hex (#RRGGBB) a string "R G B" usable en CSS vars con Tailwind.
 */
export function hexToRgbString(hex: string): string {
  const cleaned = hex.replace('#', '');
  const r = parseInt(cleaned.substring(0, 2), 16);
  const g = parseInt(cleaned.substring(2, 4), 16);
  const b = parseInt(cleaned.substring(4, 6), 16);
  return `${r} ${g} ${b}`;
}

/**
 * Oscurece un hex el % indicado (0-100).
 */
export function darken(hex: string, percent: number): string {
  const cleaned = hex.replace('#', '');
  const factor = 1 - percent / 100;
  const r = Math.max(0, Math.round(parseInt(cleaned.substring(0, 2), 16) * factor));
  const g = Math.max(0, Math.round(parseInt(cleaned.substring(2, 4), 16) * factor));
  const b = Math.max(0, Math.round(parseInt(cleaned.substring(4, 6), 16) * factor));
  return `#${[r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('')}`;
}

/**
 * Aplica el color primario del negocio a las CSS vars globales.
 */
export function aplicarColorPrimario(hex: string): void {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', hexToRgbString(hex));
  root.style.setProperty('--color-primary-hover', hexToRgbString(darken(hex, 15)));
}
